import { render, staticRenderFns } from "./CenBsCollFromRegList.vue?vue&type=template&id=5dee977c&scoped=true&"
import script from "./CenBsCollFromRegList.vue?vue&type=script&lang=js&"
export * from "./CenBsCollFromRegList.vue?vue&type=script&lang=js&"
import style0 from "./CenBsCollFromRegList.vue?vue&type=style&index=0&id=5dee977c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee977c",
  null
  
)

export default component.exports